import { Expression } from '../../types';
import { TypedExpressions } from '../filter-builder';

export default function compileExpressions(
  expressions: Expression[],
): TypedExpressions | null {
  if (!expressions.length) {
    return null;
  }

  const compiled: TypedExpressions[] = [];

  const groupExpressions = () => {
    const grouped: Record<string, Expression[]> = {};
    expressions.forEach((expression) => {
      const { field } = expression;
      if (!grouped[field]) {
        grouped[field] = [];
      }
      grouped[field].push(expression);
    });
    return grouped;
  };

  const expandIntoOrConditionIfNeeded = (
    expression: Expression,
  ): Expression | TypedExpressions => {
    const {
      field, operator, value, options,
    } = expression;

    const isTextOperator = operator && operator.startsWith('text_');
    if (!isTextOperator || value.length === 1) {
      return expression;
    }

    const eachValueAsAnExpression = value.map((val) => (options
      ? {
        field, operator, value: [val], options,
      }
      : { field, operator, value: [val] }
    ));

    return {
      type: 'or',
      expressions: eachValueAsAnExpression,
    };
  };

  const groupedExpressions = groupExpressions();
  const keys = Object.keys(groupedExpressions);
  keys.forEach((key) => {
    const expressionsForKey: (Expression | TypedExpressions)[] = [];
    groupedExpressions[key].forEach((rawExpression) => {
      const withOrs: Expression | TypedExpressions = expandIntoOrConditionIfNeeded(rawExpression);
      expressionsForKey.push(withOrs);
    });

    if (expressionsForKey.length === 1 && (expressionsForKey[0] as TypedExpressions).type) {
      compiled.push((expressionsForKey[0] as TypedExpressions));
    } else {
      compiled.push({ type: 'and', expressions: expressionsForKey });
    }
  });

  if (compiled.length > 1) {
    return { type: 'and', expressions: compiled };
  }
  return compiled[0];
}
